import { useEffect } from 'react';
import echo from '../services/echo';

/**
 * QR sifarişləri real-time dinləyən hook.
 *
 * @param {number} restaurantId - Cari restoranın ID-si (auth-dan gəlir)
 * @param {function} onNewOrder - Yeni sifariş gələndə çağrılan callback
 */
export function useQrOrderListener<TPayload = unknown>(
    restaurantId: number | string | null,
    onNewOrder: (data: TPayload) => void
): void {
    useEffect(() => {
        if (!restaurantId) return;

        const channelName = `restaurant.${restaurantId}.orders`;
        const channel = echo.channel(channelName);

        channel.listen('.new-qr-order', (data: TPayload) => {
            onNewOrder(data);
        });

        // Cleanup — component unmount olanda kanaldan çıx
        return () => {
            echo.leaveChannel(channelName);
        };
    }, [restaurantId, onNewOrder]);
}

